import antdEn from 'antd/lib/locale-provider/en_US';
import appLocaleData from 'react-intl/locale-data/en';
import rbac from '../locales/en/rbac';
import clients from '../locales/en/client';
import tasks from '../locales/en/task';
import services from '../locales/en/service';
import projects from '../locales/en/project';
import common from '../locales/en/common';
import users from '../locales/en/user';
import credentials from '../locales/en/credential';
import account from '../locales/en/account';
import articles from '../locales/en/article';
import events from '../locales/en/event';
import legalEntity from '../locales/en/legalEntity';
import comments from '../locales/en/comment';
import timer from '../locales/en/timer';
import file from '../locales/en/file';
import notifications from '../locales/en/notifications';
import home from '../locales/en/home';
import report from '../locales/en/report';
import emoji from '../locales/en/emoji';
import setUpWizard from '../locales/en/setUpWizard.json';
import help from '../locales/en/help';
import iso3166countries from '../locales/en/iso3166codes.json';
import search from '../locales/ru/search';

const EnLang = {
  messages: {
    ...rbac,
    ...clients,
    ...tasks,
    ...services,
    ...projects,
    ...users,
    ...credentials,
    ...common,
    ...account,
    ...articles,
    ...events,
    ...legalEntity,
    ...comments,
    ...timer,
    ...file,
    ...notifications,
    ...home,
    ...report,
    ...emoji,
    ...setUpWizard,
    ...help,
    ...iso3166countries,
    ...search,
  },
  antd: antdEn,
  locale: 'en-US',
  data: appLocaleData,
};
export default EnLang;
